import React, { useState, useEffect, useContext } from "react";
import BqnContext from "common/BqnContext";
import Request from "common/Request";
import Result from "./Result";
import {
  parsePoolMemoryUsage,
  parseDPDKMemoryUsage,
  parseSystemMemoryCluster,
} from "./api.js";
import ActionsContext from "common/ActionsContext";
import View from "common/View";

export const memoryUsageRetrieval = (mode) =>
  Promise.all([
    ifCl.run("show system memory").then((response)=>parseSystemMemoryCluster(response, mode)),
    ifCl.run("show pkteng memory").then((response)=>parsePoolMemoryUsage(response, mode)),
    ifCl.run("show pkteng memory dpdk").then((response)=>parseDPDKMemoryUsage(response, mode)),
  ]).then(([System, Mpool, Dpdk]) => ({ System, Mpool, Dpdk }));

const Report = () => {
  const {clusterStatus: {mode}} = useContext(BqnContext);
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);

  const doLoad = () => {
    setRequest(memoryUsageRetrieval(mode));
  };

  useEffect(() => doLoad() || actions.recv("do-load", doLoad), []);

  return (
    <Request during={request}>
      {(response) => <Result {...response} />}
    </Request>
  );
};

const MemoryStatus = () => (
  <View title="Memory Usage">
    <Report />
  </View>
) 
export default MemoryStatus;
